import axios from 'axios';
import authHeader from './AuthHeader';
import { AppConstants } from '../constants/AppConstants';
import DeliveryEntity from "../types/deliveryEntity.type";

class DeliveryService {

  getUserDeliveries(userId: number) {
      return axios.get(AppConstants.API_URL + '/deliveries/' + userId, { headers: authHeader() });
  }


  getDeliveriesBoard() {
    return axios.get(AppConstants.API_URL + '/deliveries/all-deliveries', { headers: authHeader() });
  }


  updateDelivery(delivery: DeliveryEntity) {
    if (delivery.id == null) throw new Error("Delivery ID is required");
    return axios.put(AppConstants.API_URL + '/deliveries/' + delivery.id, delivery, {
      headers: authHeader(),
    });
  }

  deleteDelivery(deliveryId: number) {
    return axios.delete(AppConstants.API_URL + '/deliveries/' + deliveryId, {
      headers: authHeader(),
    });
  }
}

export default new DeliveryService();